module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sl":{"slo":"Slovenščina","eng":"English","nem":"Deutsch","fra":"Français","ita":"Italiano","bih":"Bosanščina"},"en":{"slo":"Slovenščina","eng":"English","nem":"Deutsch","fra":"Français","ita":"Italiano","bih":"Bosanščina"},"de":{"slo":"Slovenščina","eng":"English","nem":"Deutsch","fra":"Français","ita":"Italiano","bih":"Bosanščina"}}')
  delete Component.options._Ctor
}
